"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toNetworkType = exports.getSigHash = void 0;
const types_1 = require("@shapeshiftoss/types");
const getSigHash = (inputData) => {
    if (!inputData)
        return;
    const length = inputData.startsWith('0x') ? 10 : 8;
    return inputData.substr(0, length);
};
exports.getSigHash = getSigHash;
const toNetworkType = (network) => {
    switch (network) {
        case 'mainnet':
            return types_1.NetworkTypes.MAINNET;
        case 'ropsten':
            return types_1.NetworkTypes.ETH_ROPSTEN;
        default:
            throw new Error('unsupported network');
    }
};
exports.toNetworkType = toNetworkType;
